export default {
      id: "dots-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#dots-usage",
      toString: function () {
        return this.url;
      }
    }